/** @format */

import {METHOD_CREDIT_CARD} from 'frontier-constants';
import {IfElse, If} from 'frontier-utilities';
import React from 'react';

export const NameColumn = props => {
    const [isLoading, setIsLoading] = React.useState(false);

    const {paymentProfile} = props;

    const paymentTypeLabel =
        paymentProfile.account_type_id === METHOD_CREDIT_CARD ? 'Card' : 'Account';
    return (
        <div className="payment-form-93ht-table__name d-flex align-items-center justify-content-start gap-4">
            {/* Omitting for now */}
            {/*<button className="m-0 p-0" onClick={() => {}}>
                <IfElse condition={isLoading}>
                    <i
                        className="fa fa-spinner fa-spin color-structure-darker"
                        style={{fontSize: 24}}
                    />
                    <IfElse condition={paymentProfile.is_default}>
                        <i
                            className="color-accent-primary fa-solid fa-star"
                            style={{fontSize: 24}}
                        />
                        <i
                            className="color-structure-darker fa-regular fa-star"
                            style={{fontSize: 24}}
                        />
                    </IfElse>
                </IfElse>
            </button>*/}
            <div>
                <If condition={paymentProfile.is_default}>
                    <p className="m-0 color-structure-darker">Default</p>
                </If>
                <h5 className="m-0">{paymentProfile.name?.split('(')[0].trim()}</h5>
                <p className="m-0">
                    {paymentTypeLabel} Ending ****{paymentProfile.account_last_four}
                </p>
            </div>
        </div>
    );
};
